var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbortedWashes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5C16.0222 5 12.2069 6.58037 9.39269 9.39269C6.58019 12.2065 5 16.0222 5 20C5 23.9778 6.58037 27.7931 9.39269 30.6073C12.2065 33.4198 16.0222 35 20 35C23.9778 35 27.7931 33.4196 30.6073 30.6073C33.4198 27.7935 35 23.9778 35 20C35 16.0222 33.4196 12.2069 30.6073 9.39269C27.7935 6.58019 23.9778 5 20 5ZM26.6535 25.1322C26.8557 25.3331 26.9709 25.6077 26.9709 25.893C26.9709 26.1783 26.8557 26.4528 26.6535 26.6537C26.4526 26.8559 26.178 26.9711 25.8928 26.9711C25.6075 26.9711 25.3329 26.8559 25.132 26.6537L19.9998 21.5108L14.8676 26.6537C14.6667 26.8559 14.3921 26.9711 14.1068 26.9711C13.8215 26.9711 13.547 26.8559 13.3461 26.6537C13.1439 26.4528 13.0287 26.1783 13.0287 25.893C13.0287 25.6077 13.1439 25.3331 13.3461 25.1322L18.489 20L13.3461 14.8678C12.9256 14.4472 12.9256 13.7669 13.3461 13.3463C13.7667 12.9258 14.447 12.9258 14.8675 13.3463L19.9998 18.4892L25.132 13.3463C25.5525 12.9258 26.2329 12.9258 26.6534 13.3463C27.074 13.7669 27.074 14.4472 26.6534 14.8678L21.5106 20L26.6535 25.1322Z",
    fill: "#EB5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbortedWashes);
export default __webpack_public_path__ + "static/media/abortedWashes.50e2ae8c3360a3e20052a998734ac466.svg";
export { ForwardRef as ReactComponent };